// extracted by mini-css-extract-plugin
export var content = "_mj-1";
export var divider = "_mj-0";